<template>
	<vs-row class="mb-6">
		<vs-col vs-w="3">
			<span v-if="results"> {{ results.length }} results </span
			><span>&nbsp;</span>
		</vs-col>
		<vs-col vs-w="9" class="flex justify-between items-center">
			<div class="flex-grow">
				<div class="pl-4" v-if="activeFilters">
					<vs-chip
						v-for="filter in activeFilters"
						@click="removeFilter(filter)"
						:key="'' + filter.val"
						closable
						class="mr-5"
					>
						{{ filter.displayVal || filter.val }}
					</vs-chip>
				</div>
				<div class="pl-4" v-if="suggestedFilters">
					<vs-chip
						color="primary"
						v-for="filter in suggestedFilters"
						:key="'' + filter.val"
						class="mr-5"
						@click="addSuggestedFilter(filter)"
					>
						<vs-avatar
							icon-pack="feather"
							icon="icon-plus"
							@click="addSuggestedFilter(filter)"
						/>
						<span>
							{{ filter.displayVal || filter.val }}
						</span>
					</vs-chip>
				</div>
			</div>

			<div class="" v-if="results">
				<vs-dropdown class="mx-4">
					<span>
						Sort by {{ activeSortLabel }}
						<vs-icon class="" icon="expand_more"></vs-icon>
					</span>
					<vs-dropdown-menu>
						<vs-dropdown-item
							class="whitespace-no-wrap"
							v-for="sortOption in sortOptions"
							:key="sortOption.label"
							v-on:click="setSortOption(sortOption.sortBy)"
						>
							{{ sortOption.label }}</vs-dropdown-item
						>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
		</vs-col>
	</vs-row>
</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      required: true
    },
    nullFilter: {
      type: Object,
      required: true
    },
    suggestedFilters: {
      type: Array,
      required: false
    },
    results: {
      type: Array,
      required: false
    },
    sortBy: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      rangeFilter: ['priceRange', 'duration'],
      sortOptions: [
        {
          label: 'matching',
          sortBy: {
            field: 'matchingScore',
            order: 1
          }
        },
        {
          label: 'price change',
          sortBy: {
            field: 'priceChangePercent',
            order: -1
          }
        }
      ]
    }
  },
  computed: {
    activeSortLabel () {
      const a = this.sortOptions.filter(
        (o) => JSON.stringify(o.sortBy) === JSON.stringify(this.sortBy)
      )
      return a[0] ? a[0].label : ''
    },
    activeFilters () {
      const that = this
      //return [this.filter.region, this.filter.cruiseLine, this.filter.cabinType].flatMap(f=> f);
      const af = [
        'region',
        'cruiseLine',
        'cabinType',
        'importantAmenities'
      ].flatMap((filter) => (that.filter[filter] || []).map(function (val) {
        return {
          filter,
          val
        }
      })
      )

      if (that.filter.date) {
        af.push({
          filter: 'date',
          displayVal: that.filter.date.toLocaleDateString('en-US', {
            month: 'short',
            year: 'numeric'
          }),
          val: that.filter.date
        })
      }

      // range filters: include if they do not have default values
      this.rangeFilter.map(function (f) {
        if (
          JSON.stringify(that.filter[f]) === JSON.stringify(that.nullFilter[f])
        ) {
          // ignore
        } else {
          af.push({
            filter: f,
            val:
              `${that.filter[f].join(' - ')  } ${(f === 'duration' ? 'days' : 'USD')}`
          })
        }
      })

      return af
    }
  },
  methods: {
    removeFilter (activeFilter) {
      if (activeFilter.filter === 'date') {
        this.filter.date = null
      } else if (this.rangeFilter.includes(activeFilter.filter)) {
        // need to clear a range filter
        this.filter[activeFilter.filter] = this.nullFilter[activeFilter.filter]
      } else {
        // multiselect filters
        this.filter[activeFilter.filter] = this.filter[
          activeFilter.filter
        ].filter((val) => val !== activeFilter.val)
      }
    },
    addSuggestedFilter (newFilter) {
      console.log('ADDING SUGGESTED FILTER', newFilter)
      this.filter[newFilter.filter] = newFilter.val
    },
    setSortOption (sortBy) {
      Object.assign(this.sortBy, sortBy)
    }
  }
}
</script>
